'use client';

import { createContext, type ReactNode, useContext } from 'react';
import type { HpPriceHistoryResponseDto } from '@zg-rentals/ts-hotpads-api-client';
import type { PriceHistoryIdentity } from '@/src/lib/utils/priceHistoryIdentity';
import { usePriceHistory } from '@/src/lib/hooks/query/usePriceHistory';
import { toHotpadsClickstreamListing } from '@/src/analytics/hotpads/track';
import type { HotpadsClickstreamListing } from '@/src/analytics/hotpads/types';
import type { PropertyDetailListing } from '../types';
import { canRetainData } from '../moduleRegistry';

const PriceHistoryContext = createContext<{
  history?: HpPriceHistoryResponseDto;
  identity?: PriceHistoryIdentity;
  listing: HotpadsClickstreamListing | null;
}>({ listing: null });

export function PriceHistoryProvider({ listing, children }: { listing: PropertyDetailListing; children: ReactNode }) {
  const { history } = usePriceHistory(canRetainData(listing) ? listing.priceHistoryIdentity : undefined);
  return (
    <PriceHistoryContext.Provider
      value={{ history, identity: listing.priceHistoryIdentity, listing: toHotpadsClickstreamListing(listing) }}
    >
      {children}
    </PriceHistoryContext.Provider>
  );
}

export const usePriceHistoryContext = () => useContext(PriceHistoryContext);
